// Community Discord Subpage - Discord integration (coming soon)
// Rendered inside CommunityLayout (supporter-gated)

import { useManager } from '../../../../core';
import { useAuthRequired } from '../../../../contexts/AuthContext';
import { CommunityManager } from '../../managers/community-manager';
import { DiscordCommunityHub } from '../../components';
import '../../CommunityShared.css';
import '../../CommunitySection.css';
import '../../components/DiscordCommunityHub.css';

export function CommunityDiscordSection() {
  const auth = useAuthRequired({
    payload: {
      action: 'viewCommunityDiscord',
      section: 'community',
      timestamp: Date.now(),
    },
    requireAuth: true,
    requireSupporter: false,
  });

  const { isInitialized } = useManager(CommunityManager);

  if (auth.loading || !auth.isAuthorized) return null;

  if (!isInitialized) {
    return (
      <div className="community-panel">
        <div style={{ color: '#999' }}>Loading...</div>
      </div>
    );
  }

  return <DiscordCommunityHub />;
}
